import { ICustomIcons } from '../interface';

export const CryptoControl: React.FC<ICustomIcons> = ({
  width = '28',
  height = '16',
  color = '#11141B',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.706 2.23888C23.5361 0.115204 20.0057 0.115204 17.8358 2.23888L16.6489 3.40031L15.1338 4.88309L11.6529 8.28999L10.4319 9.48478L8.05875 11.8076C7.04982 12.7949 5.40843 12.7949 4.39972 11.8076C3.39079 10.8202 3.39079 9.21376 4.39972 8.22633L7.9937 4.7087C9.00263 3.72147 10.644 3.72147 11.6529 4.7089C12.0692 5.11644 12.3109 5.62961 12.3835 6.16099L14.7042 3.88993C14.4566 3.44431 14.1433 3.0247 13.7584 2.64827C11.5887 0.524587 8.05812 0.524588 5.88822 2.64806L2.29402 6.16569C0.124324 8.28917 0.124324 11.7448 2.29402 13.8683C4.46392 15.9919 7.99454 15.9917 10.1642 13.8683L12.8662 11.2238L16.3473 7.81694L18.6027 5.60955L19.9413 4.29952C20.9502 3.31229 22.5916 3.31229 23.6005 4.29952C24.6092 5.28695 24.6092 6.89337 23.6005 7.88081L20.0065 11.3982C18.9976 12.3857 17.356 12.3857 16.3473 11.3982C15.9309 10.9907 15.6891 10.4775 15.6165 9.94595L13.2958 12.2172C13.5434 12.6628 13.8569 13.0824 14.2416 13.4591C16.4115 15.5825 19.9421 15.5825 22.112 13.4591L25.706 9.94144C27.8759 7.81776 27.8759 4.36256 25.706 2.23888Z"
        fill={color}
      />
    </svg>
  );
};
